{
  "dashboard": {
    "title": "Cuadro de mando"
  },
  "devices": {
    "title": "Equipos"
  },
  "device": {
    "title": "Apparato"
  },
  "dtwins": {
    "title": "Device twins"
  },
  "dtwin": {
    "title": "Equipo LPP4"
  },
  "users": {
    "title": "Usuarios"
  },
  "user": {
    "title": "Usuarios"
  },
  "profiles": {
    "title": "Perfiles"
  },
  "applications": {
    "title": "Aplicaciones"
  },
  "campaigns": {
    "title": "Campañas"
  },
  "logs": {
    "title": "Cuaderno de bitácora"
  },
  "sectors": {
    "details": {
      "title": "Detalles de la red {name}"
    },
    "title": "Sectores"
  },
  "parameters": {
    "title": "Configuración"
  },
  "userGroups": {
    "title": "Grupos"
  },
  "pkiConnector": {
    "title": "Conector PKI"
  },
  "truststore": {
    "title": "Truststore"
  },
  "firmware": {
    "title": "Firmwares"
  },
  "filters": "Filtros",
  "certificateAlertReporting": {
    "title": "Informes"
  },
  "certificate-management": {
    "title": "Certificados"
  },
  "applicationMgts": {
    "title": "Aplicaciones"
  },
  "license": {
    "title": "Licencia"
  },
  "userAccount": {
    "title": "Cuenta de usuario"
  },
  "about": {
    "title": "Acerca de",
    "downloadTitle": "Descargar los registros"
  },
  "deviceConfiguration": {
    "title": "Configuración de los equipos"
  },
  "platformMgt": {
    "title": "Acerca de",
    "downloadTitle": "Descargar los registros"
  },
  "componentsVersion": {
    "title": "Acerca de"
  },
  "certificates": {
    "title": "Certificados"
  },
  "fleets": {
    "title": "Flotas"
  },
  "businessUnits": {
    "title": "Modificar {name}"
  },
  "organizations": {
    "title": "Modificar {name}"
  }
}
